<template>
  <div>
    <div class="detail-page" v-if="!offSale">
      <div class="detail-main">
        <!-- 详情展示的子组件 -->
        <mall-commodity-goods-detail :obj="obj" v-if="commodityType == 0"></mall-commodity-goods-detail>
        <mall-class-detail :obj="obj" v-else-if="commodityType == 1"></mall-class-detail>
      </div>
      <div class="footer" v-if="teacherId">
        <van-button block square round type="primary" @click="toShare">分享</van-button>
      </div>
      <div class="footer" v-else>
        <div class="footer-left" @click="toMallList">
          <svg class="vxm-icon" aria-hidden="true" font-size="24">
            <use xlink:href="#vxm-icon-huidaoshouye"></use>
          </svg>
          <div>首页</div>
        </div>
        <div class="footer-left" @click="toShare">
          <svg class="vxm-icon" aria-hidden="true" font-size="24">
            <use xlink:href="#vxm-icon-fenxiang"></use>
          </svg>
          <div>分享</div>
        </div>
        <div class="footer-right">
          <van-button 
            block square round type="primary" 
            @click="beforeOrderSubmit" 
            :disabled="(!obj.commodityPriceItemDetailList ||!obj.commodityPriceItemDetailList.length) && commodityType!==0">
            {{commodityType==0?'立即购买':'立即报名'}}
          </van-button>
        </div>
      </div>
      <!-- 班级商品选择规格 -->
      <van-action-sheet v-model="showClassPriceSelection">
        <div class="price-action-sheet-title">
          <van-icon name="cross" class="close" @click="showClassPriceSelection = false"/>
          <div class="van-ellipsis">{{obj.commodityName}}</div>
          <div class="sub-title" v-if="choicePriceId">
            <span class="price">¥{{ choicePriceObj.price | formatNumber }}</span><span class="num">共{{ choicePriceObj.priceNum }}{{choicePriceObj.priceUnit}}</span>
            <div class="discount" v-if="!choicePriceObj.originalPrice">已减¥{{ choicePriceObj.discount | formatNumber }}</div>
          </div>
        </div>
        <div class="price-action-sheet">
          <div class="title van-hairline--top">课程规格</div>
          <div class="price-wrapper">
            <div class="price-item"
              v-for="item in priceList"
              :key="item.id"
              @click="choosePrice(item)"
              :class="{ 'active-price': choicePriceId === item.id }">{{item.priceName}}·{{item.priceNum}}{{item.priceUnit}}</div>
          </div>
          <div class="footer">
            <van-button 
              block square round type="primary" @click="toOrderSubmit" 
              >
                立即购买
            </van-button>
          </div>
        </div>
      </van-action-sheet>
      <!-- 物品商品选择规格 -->
      <van-action-sheet v-model="showGoodsPriceSelection">
        <div class="price-action-sheet-title">
          <van-icon name="cross" class="close" @click="showGoodsPriceSelection = false"/>
          <div class="van-ellipsis">{{obj.commodityName}}</div>
          <div class="sub-title" v-if="choicePriceId">
            <span class="price">¥{{ choicePriceObj.price | formatNumber }}</span><span class="num">/{{choicePriceObj.priceUnit}}</span>
          </div>
          <div class="sub-title" v-if="choicePriceId && choiceCampusId">
            <span class="num">剩余数量：{{ choicePriceStock ? choicePriceStock : "无货"}}</span>
          </div>
        </div>
        <div class="price-action-sheet">
          <div class="title van-hairline--top">物品领取校区</div>
          <div class="price-wrapper">
            <div class="price-item"
              v-for="item in obj.campusList"
              :key="item.id"
              @click="choiceCampusId = item.id"
              :class="{ 'active-price': choiceCampusId === item.id }">{{item.name}}</div>
          </div>
          <div class="title">物品规格</div>
          <div class="price-wrapper">
            <div class="price-item"
              v-for="item in priceList"
              :key="item.id"
              @click="choosePrice(item)"
              :class="{ 'active-price': choicePriceId === item.id }">{{item.priceName}}</div>
          </div>
          <div class="footer">
            <van-button block square round type="primary" @click="toOrderSubmit" v-if="choicePriceStock">立即购买</van-button>
            <van-button block square round v-else>暂无库存</van-button>
          </div>
        </div>
      </van-action-sheet>
    </div>
    <van-empty v-else class="detail-page" description="商品已下架">
      <van-button square round type="primary" style="width: 148px" @click="offSaleTo">确定</van-button>
    </van-empty>
  </div>
</template>

<script>
import mallClassDetail from "./child/mall-class-detail.vue";
import mallCommodityGoodsDetail from "./child/mall-commodityGoods-detail.vue";

function precision(num) {
  return parseFloat(Number(num).toPrecision(12));
}

export default{
  components: { mallClassDetail, mallCommodityGoodsDetail },
  name: 'product-detail',
  mixins: [app.mixin.share],
  data() {
    return {
      pageTitle: '商品详情',
      id: this.$route.params.id,
      // 分享老师ID
      teacherId: this.$route.query.teacherId,
      // 分享ID
      shareId: this.$route.query.shareId,
      obj: {},
      offSale: false, // 是否下架
      showClassPriceSelection: false, // 显示价格选择弹窗
      showGoodsPriceSelection: false, // 
      choicePriceId: null, // 选择的价格
      choicePriceObj: {}, // 选择的价格对象
      choiceCampusId: null, //选择的校区
      choicePriceStock: '',
      priceList: [], // 商品价格列表
      commodityType: parseInt(this.$route.query.commodityType),
      parentId: this.$route.query.parentId,
    };
  },
  computed: {
    choicePriceChange() {
      const {choicePriceId, choiceCampusId} = this;
      return {choicePriceId, choiceCampusId}
    }
  },
  watch: {
    ...Vuex.mapState(['lessonUnit']),
    choicePriceChange: {
      handler: function(newVal, oldVal) {
        if (this.commodityType == 0 && this.choiceCampusId && this.choicePriceId) {
          this.getGoodsStock();
        }
      },
      deep: true,
    }
  },
  methods: {
    offSaleTo() {
      if (this.teacherId) {
        history.back();
      } else {
        this.toMallList();
      }
    },
    toMallList() {
      this.$router.push(`/mall/${this.obj.companyId}`);
    },
    toShare() {
      // 展示弹窗提示
      app.x3.popup.share();
    },
    choosePrice(p) {
      this.choicePriceId = p.id;
      this.choicePriceObj = p;
    },
    beforeOrderSubmit() {
      if (this.commodityType == 1) {
        if (this.priceList.length == 1) {
          this.$router.push(`/orderSubmit?id=${this.id}&commodityType=${this.commodityType}&parentId=${this.parentId}`);
        } else {
          this.showClassPriceSelection = true;
        }
      } else if (this.commodityType == 0) { // 物品：默认选第一个校区和规格&&发请求拿库存
        this.showGoodsPriceSelection = true;
        this.choiceCampusId = (this.obj.campusList&&this.obj.campusList.length>0)?this.obj.campusList[0].id:'';
        this.choicePriceObj = (this.priceList&&this.priceList.length>0)?this.priceList[0]:{};
        this.choicePriceId = (this.priceList&&this.priceList.length>0)?this.priceList[0].id:'';
      }
    },
    toOrderSubmit() {
      if (this.commodityType == 1) {
        if (!this.choicePriceId) {
          this.$toast('请选择课程规格');
          return;
        }
        this.$router.push(`/orderSubmit?id=${this.id}&priceId=${this.choicePriceId}&commodityType=${this.commodityType}&parentId=${this.parentId}`);
        this.showClassPriceSelection = false;
      } else if (this.commodityType == 0) {
        if (!this.choiceCampusId) {
          this.$toast('请选择物品领取校区');
          return;
        }
        if (!this.choicePriceId) {
          this.$toast('请选择物品规格');
          return;
        }
        this.$router.push(`/orderSubmit?id=${this.id}&priceId=${this.choicePriceId}&commodityType=${this.commodityType}&commodityCampus=${this.choiceCampusId}&parentId=${this.parentId}`);
        this.showGoodsPriceSelection = false;
      }
    },
    setShare() {
      // 设置分享
      this.$api
        .getCommodityShareInfo({
          commodityId: this.obj.id,
          companyId: this.obj.companyId,
          teacherId: this.teacherId,
          shareId: this.shareId,
          commodityType: this.commodityType,
        })
        .then(res => {
          this.app_share_resolve({
            title: this.obj.commodityName,
            desc: this.obj.companyName || '',
            link: `${location.href.split('#')[0]}#/detail/${this.id}?shareId=${res.data.shareId}&commodityType=${this.commodityType}&parentId=${app.parent.user.id}`,
            imgUrl: this.obj.coverMap && this.obj.coverMap.url,
          });          
          console.log(`${location.href.split('#')[0]}#/detail/${this.id}?shareId=${res.data.shareId}&commodityType=${this.commodityType}&parentId=${app.parent.user.id}`);
        });    
      //增加分享链接的浏览量_伍志长
      if (this.shareId && this.shareId !== 'undefined' && this.shareId !== 'null') {
        this.$api.addPageviews({
          companyId: this.obj.companyId,
          shareId: this.shareId,
        });
      }
    },
    getDetailData() {
      this.showLoading();
      let _pro = this.commodityType == 1 ? this.$api.queryCommodityGet : this.$api.studentGoodsDetails;
      let params = this.commodityType == 1 ? {
        commodityInfoId: this.id
      } : {
        commodityGoodsId: this.id
      };
      _pro(params).then(res => {
          vant.Toast.clear();
          if (res.code === 200) {
            if (res.data.shelfStatus == 1) {
              if (this.commodityType == 1) {
                this.priceList = res.data.commodityPriceItemDetailList.map(item => {
                  let oPrice = precision(item.priceNum * res.data.originalPrice);
                  let discount = precision(oPrice - item.price);
                  return {
                    id: item.id,
                    priceName: item.priceName,
                    priceNum: item.priceNum,
                    priceUnit: item.priceUnitName,
                    price: item.price,
                    originalPrice: item.originalPrice,
                    oPrice,
                    discount,
                  };
                });
              }else if(this.commodityType == 0){
                this.priceList = res.data.commodityPriceItemList.map(item=> {
                  return {
                    id: item.priceItemId,
                    priceName: item.priceName,
                    price: item.price,
                    priceUnit: item.priceUnitName
                  }
                })
              }
              this.obj = res.data;
              if (!this.obj.coverMap) {
                this.$set(this.obj, 'coverMap', {
                  url: 'https://cdn01.xiaogj.com/file/02f7ff5c926b4a97a903f7026bbde3c6/202007/fa57ceffb91949bc911468e163a13c95.png',
                });
              }
              this.setShare();
            } else {
              this.obj.companyId = res.data.companyId;
              this.offSale = true;
            }
          } else {
            this.$toast.fail(res.msg);
          }
        });
    },
    getGoodsStock() {
      this.showLoading();
      this.$api.checkStudentGoodsStock({
        id: this.obj.id,
        companyId: this.obj.companyId,
        campusId: this.choiceCampusId,
        priceItemId: this.choicePriceId,
      }).then(res=> {
        this.$toast.clear();
        if (res.code===200) {
          this.choicePriceStock = res.data;
        } else {
          this.$toast.fail(res.msg);
        }
      })
    }
  },
  created() {
    this.getDetailData();

    this.$onBus('refresh-product-detail', () => {
      this.getDetailData();
      this.choicePriceId = null;
      this.choicePriceObj = {};
      this.choiceCampusId = null;
    });
  },
};
</script>

<style lang="scss" scoped>
.detail-page {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  .detail-main {
    flex: 1;
    overflow: auto;
  }
  .footer {
    display: flex;
    align-items: center;
    background-color: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    ::v-deep .van-button {
      height: calc(var(--w) * 40);
    }
    .footer-left {
      flex-shrink: 0;
      margin: 0 calc(var(--gap) * 24) 0 calc(var(--gap) * 8);
      font-size: var(--fs-xs);
      line-height: var(--lh-xs);
      color: var(--g7);
      text-align: center;
    }
    .footer-right {
      flex: 1;
    }
  }
  .price-action-sheet-title {
    padding: calc(var(--gap) * 16);
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
    font-weight: var(--bold);
    position: relative;
    padding-right: calc(var(--gap) * 46px);
    .close {
      position: absolute;
      right: calc(var(--gap) * 20);
      top: calc(var(--gap) * 20);
      color: var(--g5);
      font-size:var(--fs-md);
    }
    .sub-title {
      margin-top: calc(var(--gap) * 7);
      display: flex;
      align-items: center;
      .price {
        color: var(--c1);
        margin-right: calc(var(--gap) * 4);
      }
      .num {
        font-size: var(--fs-sm);
        color: var(--g6);
        font-weight: normal;
      }
      .discount {
        display: inline-block;
        min-width: calc(var(--w) * 56);
        height: calc(var(--w) * 16);
        padding: 0 calc(var(--gap) * 6);
        line-height: calc(var(--w) * 16);
        text-align: center;
        background-color: #F56C6C;
        color: var(--white);
        border-radius: var(--radius-sm) var(--radius-sm) var(--radius-sm) 0px;
        font-size: var(--fs-xs);
        font-weight: normal;
      }
    }
  }
  .price-action-sheet {
    color: var(--g6);
    .title {
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
    }
    .price-wrapper {
      max-height: calc(var(--w) * 312);
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      .price-item {
        margin: 0 calc(var(--gap) * 10) calc(var(--gap) * 12);
        display: flex;
        align-items: center;
        position: relative;
        border-radius: 8px;
        background-color: #fafafa;
        padding: 11px 16px;
        border: 1px solid #fafafa;
        color: var(--g8);
        &.active-price {
          color: var(--c1);
          border-color: var(--c1);
          background: rgba(255, 116, 55, 0.04);
        }
      }
    }
    .footer {
      background-color: var(--white);
      padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
      ::v-deep .van-button {
        height: calc(var(--w) * 40);
      }
    }
  }
}
</style>
